var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.thumbnail)?_c('ThumbnailPost',_vm._b({},'ThumbnailPost',_vm.$props,false)):_c('Post',_vm._b({},'Post',_vm.$props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-008bca67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OtherPost/OtherPost.vue
// module id = Xb9O
// module chunks = 1